export default __webpack_public_path__ + "static/media/thank_confirm.a92bd636.jpg";